import { Injectable } from '@angular/core';
import * as Rx from 'rxjs';
import { tap } from 'rxjs/operators';
import { SkillAPIService } from '../skill-api.service';
import { UserInfoService } from '../../user/user-info.service';

@Injectable({
	providedIn: 'root'
})
export class SkillProfilerService {
	loadingRC = true;
	constructor(
		private userInfo: UserInfoService,
		private api: SkillAPIService
	) {
		if (!this.userInfo.isAnonymous()) {
			this.getOccupationMatches();
		}
		else {
			this.loadingRC = false;
		}
	}

	private _anonymousAnswer: any = null;
	get anonymousAnswer(): any {
		if (this.userInfo.isAnonymous()) {
			return null;
		}
		else {
			return this._anonymousAnswer;
		}
	}
	set anonymousAnswer(v: any) {
		if (v == null) {
			this._anonymousAnswer = null;
		}
		else {
			if (this.userInfo.isAnonymous()) {
				let old = this._anonymousAnswer;
				if (old != null) {
					v.AnswerTime = old.AnswerTime;
				}
				this._anonymousAnswer = v;
			}
			else {
				this._anonymousAnswer = null;
			}
		}
	}

	private _skillProfilerAssessment: any = null;
	get skillProfilerAssessment() : any {
		return this._skillProfilerAssessment;
	}
	set skillProfilerAssessment (v: any) {
		if (v == null) {
			this._skillProfilerAssessment = null;
		}
		else {
			this._skillProfilerAssessment = v;
		}
	}

	private _skillProfilerOccupationMatches: any = null;
	get skillProfilerOccupationMatches() : any {
		return this._skillProfilerOccupationMatches;
	}
	set skillProfilerOccupationMatches (v: any) {
		if (v == null) {
			this._skillProfilerOccupationMatches = null;
		}
		else {
			this._skillProfilerOccupationMatches = v;
		}
	}

	// get matched occupation by skill answer
	getOccupationMatches(): void {
		this.loadingRC = true;
		this.api.getOccupationMatches().subscribe({
			next: (result: any) => {
				this.skillProfilerOccupationMatches = result;
				this.loadingRC = false;
			},
			error: (error: any) => {
				console.log(error);
				this.loadingRC = false;
				this.skillProfilerOccupationMatches = null;
			}
		});
	}

	//get skill fit score (called by fitness directive after it inits on loadingRC ready)
	getSkillFit(onetCode: string) : number {
		if (this.skillProfilerOccupationMatches == null) {
			return 0;
		}
		let match = this.skillProfilerOccupationMatches.SkaRankList.find((x: any) => x.OldOnetCode === onetCode);
		if (match !== undefined && match != null) {
			return match.FitScore;
		}
		else {
			return 0;
		}
	}

	saveSkillAnswers(answers: any): Rx.Observable<any> {
		let userAnswers = {
			AnswerTime: new Date(),
			Answers: answers
		};
		this.anonymousAnswer = userAnswers;
		return this.api.saveSkillAnswers(userAnswers).pipe(
			tap(
				response => {
					if (this.userInfo.isAnonymous()) {
						this.skillProfilerAssessment = userAnswers;
					}
					if (response.Code === "200") {
						this.getOccupationMatches();
					}
				}
			)
		);
	}

	getSkillAnswers(): Rx.Observable<any> {
		if (!this.userInfo.isAnonymous()) {
			return this.api.getSkillAnswers();
		}
		else {
			let sp = this.skillProfilerAssessment;
			if (sp != null && sp.Answers != null) {
				sp.HasRecommendedSOC = true;
				return Rx.of(sp);
			}
			else {
				let msg: any = { Code: "400", Detail: "No Answer" };
				return Rx.throwError(() => msg);
			}
		}
	}

	getAnonymousSkillAnswers(): Rx.Observable<any> {
		var sp = this.skillProfilerAssessment;
		if (sp != null && sp.Answers != null && sp.Answers.length > 0) {
			return Rx.of(sp.Answers);
		}
		else {
			return Rx.of(null);
		}
	}

	slides = [
		{ title: "BEST FIT", value: 'Best', iconFont: 'icnTrophy' },
		{ title: "GREAT FIT", value: 'Great', iconFont: 'icnMedal' },
		{ title: "GOOD FIT", value: 'Good', iconFont: 'icnAward' }
	];
}
